import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=54e5fdd3&scoped=true&"
import script from "./TermsOfUse.vue?vue&type=script&lang=js&"
export * from "./TermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=54e5fdd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5fdd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e5fdd3')) {
      api.createRecord('54e5fdd3', component.options)
    } else {
      api.reload('54e5fdd3', component.options)
    }
    module.hot.accept("./TermsOfUse.vue?vue&type=template&id=54e5fdd3&scoped=true&", function () {
      api.rerender('54e5fdd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenants/TermsOfUse.vue"
export default component.exports